<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import Swal from "sweetalert2";
import ExcelExport from "@/components/ExcelExport.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables Usage Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelExport
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        consumable: '',
        page: 1,
        per_page: 50
      },
      deleteData: {
        id: "",
        filterdata: {}
      },
      editData: {
        id: "",
        filterdata: {}
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Consumables Usage Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumables Usage Report",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      filteredData:[],
      todofilterOn: [],
      sortDesc: false,
      modal_id:''
    };
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("consumables", ["ConsumablesUsage","Consumables","FilterStatus","ConsumablesUsagePagination","SaveStatus"]),
    ...mapGetters("auth", ["branchid","Branches"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ConsumablesUsage?.total ?? this.totalRows;
    },

    currentPage: {
      get() {
        return this.ConsumablesUsagePagination?.current_page ?? this.data.page;
      },
      set(value) {
        this.handlePageChange(value);        
      },
    },

    perPage: {
      get() {
        return this.ConsumablesUsagePagination?.per_page ?? this.serverPerPage;
      },
      set(value) {
        this.serverPerPage = value;
        this.handlePageChange(1);        
      },
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ConsumablesUsage ? this.ConsumablesUsage.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsumableUsages: "consumables/fetchConsumablesUsage",
      FetchConsumables: "consumables/fetchConsumables",
      EditConsumablesUsage: "consumables/editConsumablesUsage",
      DeleteConsumablesUsage: "consumables/deleteConsumablesUsage",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    
    filterReport() {      
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.serverPerPage;
      this.FetchConsumableUsages(payload);
    },

    handlePageChange(newPage) {
      let payload = {
        ...this.data,
        page: newPage,
        per_page: this.serverPerPage,
      };
      this.FetchConsumableUsages(payload);
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting the consumable usages data. Please try again.",
        confirmButtonText: "OK",
      });
    },
    resetDelete() {
      this.deleteData.id = "";
    },
    resetEdit() {
      this.editData.id = "";
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
      this.deleteData.filterdata = this.data;
    },
    editConsumablesUsage(modalId) {
      this.editData.filterdata = this.data;
      this.modal_id = modalId;
      this.EditConsumablesUsage(this.editData);
    },
    deleteConsumablesUsage(modalId) {
      this.modal_id = modalId;
      this.DeleteConsumablesUsage(this.deleteData);
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchConsumableUsages(this.data);
    this.FetchConsumables();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>
            </div>            
            <div class="row">
              <div class="col-md-3 mt-4">
                <ExcelExport
                  endpoint="export_consumable_usages"
                  filename="consumable_usages_report.xlsx"
                  :payload="data"
                  button-text="Export"
                  button-variant="info"
                  icon-class="fas fa-download"
                  @export-error="handleExportError"
                />
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>ITEM</label>
                
                <model-list-select
                  :list="Consumables ? Consumables : []"
                  v-model="data.consumable"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Consumable"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6"></div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <!-- Server-side pagination -->
              <div>
                <table
                  class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
                >
                  <thead>
                    <tr>
                      <th>S/N</th>                      
                      <th>ITEM</th>
                      <th>QUANTITY</th>                    
                      <th>DATE</th>
                      <th>REASON</th>
                      <th>GIVEN TO</th>
                      <th>ADDED BY</th>
                      <th>ADDED ON</th>
                      <th v-if="branchid == 0">BRANCH</th>
                      <th>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="!FilterStatus && ConsumablesUsage && ConsumablesUsage.length > 0"
                  >
                    <template v-for="(item, index) in ConsumablesUsage">
                      <tr
                        v-for="(det, d) in item.details"
                        :key="`${item.id}-${d}`"
                      >
                        <td
                          v-if="d === 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          {{ ConsumablesUsagePagination.from + index }}
                        </td>

                        <td :class="'usage-row-end'">
                          {{ det.item_name }}
                        </td>
                        <td :class="'usage-row-end'">
                          {{ det.qty }} {{ det.unit }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          {{ item.date }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          {{ item.reason }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          {{ item.givenTo }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          {{ item.user.name }}
                        </td>                        
                        <td
                          v-if="d === 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          {{ item.addedOn }}
                        </td>
                        <td
                          v-if="d === 0 && branchid == 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          {{ item.branch }}
                        </td>
                        <td
                          v-if="d === 0"
                          :rowspan="item.details.length"
                          :class="'usage-row-end'"
                        >
                          <div>
                            <b-dropdown
                              text="More Actions..."
                              size="sm"
                              class="btn-primary"
                            >
                              <b-dropdown-item
                                v-b-modal.delete-usage-modal
                                @click="showDeleteModal({ item: item })"
                              >
                                <i class="fa fa-trash text-danger"></i>
                                <span class="text-danger"> Delete</span>
                              </b-dropdown-item>
                              <b-dropdown-item
                                v-b-modal.edit-usage-modal
                                @click="showEditModal({ item: item })"
                              >
                                <i class="fa fa-edit text-primary"></i>
                                <span class="text-primary"> Edit</span>
                              </b-dropdown-item>
                            </b-dropdown>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <!-- Loading -->
                  <tbody v-if="FilterStatus">
                    <tr>
                      <td :colspan="14" class="text-center">
                        <div class="text-warning my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="
                      !FilterStatus && (!ConsumablesUsage || ConsumablesUsage.length === 0)
                    "
                  >
                    <tr>
                      <td :colspan="14" class="text-center">
                        No sales found for the selected criteria.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Edit Consumables Usage Modal -->
            <b-modal
                header-bg-variant="warning"
                header-text-variant="light"
                body-text-variant="warning"
                footer-bg-variant="warning"
                footer-text-variant="warning"
                id="edit-usage-modal"
                hide-footer
                @hidden="resetEdit"
            >
              <template #modal-title> Edit Consumables Usage</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to return and edit this Consumables Usage? Click Proceed Button to Return Consumables Usage for Editing.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('edit-usage-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="editConsumablesUsage('edit-usage-modal')"
                >
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Processing"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>

            <b-modal
                header-bg-variant="danger"
                header-text-variant="light"
                body-text-variant="danger"
                footer-bg-variant="danger"
                footer-text-variant="danger"
                id="delete-usage-modal"
                hide-footer
                @hidden="resetDelete"
            >
              <template #modal-title> Delete Consumables Usage</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Consumables Usage? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-usage-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteConsumablesUsage('delete-usage-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>

            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

th {
  vertical-align: top;
  white-space: normal;
}
.item-container {
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.usage-row-end {
  border-bottom: 1px solid black !important;
}
.item-container-btn {
  margin-bottom: 5px;
}
</style>
